module.exports = __webpack_public_path__ + "static/OpenSans-Regular-8884e3e395cca75f48c380b3273a3f79.woff";